module.exports = __webpack_public_path__ + "img/logo-small.dc2eb3e7.png";